import request from '@/utils/request';

export function manageBlockAPI() {
    return {
        // 列表
        getManageBlockList: params => {
            return request({
                url: 'admin/manage_block/index',
                method: 'get',
                params,
            });
        },
        // 添加/修改
        editManageBlock: params => {
            return request({
                url: 'admin/manage_block/edit',
                method: 'post',
                data: params,
            });
        },
        // 详情
        getManageBlockInfo: id => {
            return request({
                url: `admin/manage_block/info?id=${id}`,
                method: 'get'
            })
        },

        //删除
        delManageBlock: params => {
            return request({
                url: 'admin/manage_block/del',
                method: 'post',
                data: params,
            });
        },

        //资源列表
        getBlockResourceList: params => {
            return request({
                url: 'admin/manage_block_resource/index',
                method: 'get',
                params,
            });
        },

        //删除资源列表
        delBlockResource: params => {
            return request({
                url: 'admin/manage_block_resource/del',
                method: 'post',
                params,
            });
        },

        //添加资源列表
        addBlockResource: params => {
            return request({
                url: 'admin/manage_block_resource/add',
                method: 'post',
                data: params,
            });
        },

    };
}
